import { HTTPStatusCode } from "@libs/api/types";
import {
  CreateApplicationType,
  ListApplicationsFilterType,
  RecentDuplicateApplicationSelectionType,
  UpdateApplicationType,
} from "@/domain/applications";
import { sendSentryError } from "@/services/sentry";
import { tsRestClient } from "@/services/ts-rest";

export const ApplicationsApi = {
  createApplication: async (body: CreateApplicationType) => {
    const res = await tsRestClient().applications.createApplication({
      body,
    });

    if (res.status === HTTPStatusCode.CREATED) {
      return res.body;
    }

    sendSentryError({
      message: "Unexpected response in ApplicationsApi.createApplication",
      error: res.body,
      shouldThrowError: true,
    });
  },
  listApplications: async (filters: ListApplicationsFilterType) => {
    const res = await tsRestClient().applications.listApplications({
      query: filters,
    });

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    sendSentryError({
      error: res.body,
      message: "Failed to list applications",
    });
  },
  getApplicationsCount: async (filters: ListApplicationsFilterType) => {
    const res = await tsRestClient().applications.getApplicationsCount({
      query: filters,
    });

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    sendSentryError({
      error: res.body,
      message: "Failed to get applications count",
    });
  },
  listRecentDuplicateApplications: async (
    selectedApplications: RecentDuplicateApplicationSelectionType[],
  ) => {
    const res =
      await tsRestClient().applications.listRecentDuplicateApplications({
        query: { selectedApplications },
      });

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    sendSentryError({
      error: res.body,
      message: "Failed to list recent duplicate applications",
      shouldThrowError: true,
    });
  },
  getApplication: async (applicationId: string) => {
    const res = await tsRestClient().applications.getApplication({
      params: { applicationId },
    });

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    sendSentryError({
      error: res.body,
      message: "Failed to get application",
      shouldThrowError: true,
    });
  },
  deleteDraftApplications: async () => {
    const res = await tsRestClient().applications.deleteDraftApplications({});

    if (res.status === HTTPStatusCode.OK) {
      return;
    }

    sendSentryError({
      error: res.body,
      message: "Failed to delete draft applications",
      shouldThrowError: true,
    });
  },
  updateApplication: async (id: string, params: UpdateApplicationType) => {
    const res = await tsRestClient().applications.updateApplication({
      params: { id },
      body: params,
    });

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    sendSentryError({
      message: "Failed to update application",
      error: res.body,
      shouldThrowError: true,
    });
  },
};
